<template>
<base-modal :modal-title="'Edit Route'" @save="save()" @close="close">
  <FormulateForm>
    <FormulateInput type="text" v-model.trim="model.name" label="Name" validation="required" />
    <FormulateInput type="select" v-model="model.integration" :options="integrationOptions" label="Integration" validation="required" />
    <FormulateInput type="checkbox" v-model="model.active" label="Active" />
  </FormulateForm>
</base-modal>
</template>

<script>
// Load the full build. 
var _ = require('lodash');
import BaseModal from 'components/modals/BaseModal';

export default {
  components: {
    BaseModal
  },
  props: {
    integrations: {
      type: Array,
      default () {
        return [];
      }
    },
    route: {
      type: Object,
      default () {
        return {
          id: null,
          name: '',
          integration: null,
          active: false,
          predicate: {'allof_set': []}
        };
      }
    },
  },

  data () {
    return {
      model: null
    };
  },
  
created () {
  this.model = _.clone(this.route, true);
  if (this.model['id'] == null) {
    this.model.id = this.randomId();
    this.model.is_new = true;
  }
  else {
    this.model.is_new = false;
  }
  //this.fetchDataTypes();
},
  computed: {
    integrationOptions: function () {
      return this.integrations.reduce(
        (a, x) => {
          a[x['id']] = x['name'];
          return a;
        },
        {}
      );
    },
    dataTypeOptions: function () {
      return this.dataTypeList.reduce(
        (a, x) => {
          a[x[0]] = x[1];
          return a;
        },
        {}
      );
    }
  },
  methods: {
    close() {
      this.$emit('close', true);
    },
    save() {
      this.$emit('save', this.model);
    },
  randomId() {
    var r1 = ("0000000" + (Math.random() * 10000000).toFixed()).substr(-7);
    var r2 = ("0000000" + (Math.random() * 10000000).toFixed()).substr(-7);
    return "temp_" + r1 + "_" + r2;
  },
    fetchDataTypes () {
      var self = this;
      API.dataTypes.getList()
        .then(function (response) {
          self.dataTypeList = response.data;
        });
    },
    saveField: _.debounce(function () {
      var requestData = {};

      // ID
      if (this.fieldModel.id) {
        requestData.id = this.fieldModel.id;
      }
      // Name
      if (this.fieldModel.name) {
        requestData.name = this.fieldModel.name;
      }
      // Data type
      if (this.fieldModel.data_type) {
        requestData.data_type = this.fieldModel.data_type;
      }
      // Field type
      if (this.fieldModel.field_type) {
        requestData.field_type = this.fieldModel.field_type;
      }

      if (requestData.name) {
        var self = this;
        API.fields.save(requestData)
          .then(function (response) {
            // closing modal
            self.$emit('close', true);
          });
      }
    })
  }

}
</script>


<style>
.form-dashboard .select2-container {
  width: 100% !important;
}
.form-dashboard #reportrange {
  background: rgb(255, 255, 255);
  cursor: pointer;
  padding: 5px 10px;
  border: 1px solid rgb(204, 204, 204);
  display: inline-block;
}
.form-dashboard .select2-container--default .select2-selection--single .select2-selection__rendered {
  padding: 6px 12px;
  height: 34px;
  line-height: 1.42857143;
}
.form-dashboard .select2-container .select2-selection--single {
  height: 34px;
  border: 1px solid #ccc;
  border-radius: 4px;
}
.form-dashboard .select2-container--default .select2-selection--single .select2-selection__arrow {
  position: absolute;
  top: 35%;
  margin-top: -8px;
  right: .5em;
}
.form-dashboard .select2-container--default .select2-selection--single .select2-selection__arrow b {
  border-color: #616161 transparent transparent transparent;
}
.form-dashboard .comiseo-daterangepicker-triggerbutton.ui-button {
  width: 100%;
  height: 34px;
  padding: 6px 12px;
  font-size: 14px;
  line-height: 1.42857143;
  color: #555;
  background-color: #fff;
  background-image: none;
  border: 1px solid #ccc;
  border-radius: 4px;
}
.form-dashboard .dropdown-toggle-filters {
  width: 100%;
  text-align: left;
}
.form-dashboard .dropdown-toggle-filters .caret {
  float: right;
  margin: 8px 0;
  color: #616161;
}

h3 {
  width: 100%;
  display: inline-block;
}
h3 .btn {
  position: sticky;
  left: 100%;
  margin-top: -7px;
  font-size: 1rem!important;
}
</style>



// WEBPACK FOOTER //
// RouteModal.vue?b24c1e9e